<template>
    <span class="user-tag">
        <a-avatar :src="user.avatar" shape="square"/>
        <a class="user-name" :href="link" target="_blank">{{ user.name }}</a>
    </span>
</template>

<script>
export default {
    props: {
        user: Object
    },
    computed: {
        link() {
            return '/user/?id=' + this.user.id;
        }
    }
}
</script>

<style lang="less" scoped>
.user-name {
    margin-left: 5px;
}
</style>